export const DecreaseIcon = ({ size = 12, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.5 8.5H3.5V3.5"
      stroke="#FE5058"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 3.5L3.5 8.5"
      stroke="#FE5058"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
